// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, string } from 'prop-types'
import { PopoverHeader, PopoverBody } from 'reactstrap'
import { FaQuestionCircle } from 'components/FontAwesome'

const DefaultContent = ({ header, content }) => (
  <>
    <PopoverHeader>
      <FaQuestionCircle />
      <span className={'padding-left-1'}>
        {header}
      </span>
    </PopoverHeader>
    <PopoverBody>
      {
        content.map((d, i) => (
          <React.Fragment
            key={i}>
            <p>
              <strong>{d.title}</strong>
              <span>{d.info}</span>
            </p>
            {d.items &&
              <ul>
                {d.items.map((item, ii) => (
                  <li key={ii}>{item}</li>
                ))}
              </ul>
            }
          </React.Fragment>
        ))
      }
    </PopoverBody>
  </>
)

DefaultContent.propTypes = {
  content: array.isRequired,
  header: string.isRequired,
}

export default DefaultContent
